import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

import { selectCurrentUser } from "../../redux/user/user.selector";
import { createStructuredSelector } from "reselect";
import ReportContainer from "../../components/report/report.container";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import {
  setCurrentReport,
  setCurrentReportById,
  getUserRating,
} from "../../redux/reports/report.actions";
import { fetchCommentsStart } from "../../redux/comments/comment.actions";
import { fetchUsersStart } from "../../redux/user/user.actions";

const ReportPage = ({
  setCurrentReportById,
  fetchCommentsStart,
  fetchUsersStart,
  currentUser,
  getRating,
}) => {
  // PATH-Property entspricht der ID des Reports
  let { berichtId } = useParams();
  const { pathname } = useLocation();
  useEffect(() => {
    fetchCommentsStart(berichtId);
    getRating(berichtId, currentUser);
    setCurrentReportById(berichtId);
    fetchUsersStart();
  }, [
    berichtId,
    fetchCommentsStart,
    getRating,
    currentUser,
    fetchUsersStart,
    setCurrentReportById,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <PageHeaderComponent title="Projektbericht" />
      <ReportContainer />
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  setCurrentReportById: (id) => dispatch(setCurrentReportById(id)),
  setCurrentReport: (report) => dispatch(setCurrentReport(report)),
  fetchCommentsStart: (id) => dispatch(fetchCommentsStart(id)),
  getRating: (report, user) => dispatch(getUserRating(report, user)),
  fetchUsersStart: () => dispatch(fetchUsersStart()),
});
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
